import { Controller } from 'stimulus';
import { toArray } from 'lodash';

class LanguageSwitch extends Controller {
  connect() {
    this.linkTargets.forEach((link) => {
      const alternateUrl = this.findUrlForLanguage(link.getAttribute('data-hreflang'));

      if (alternateUrl) {
        link.href = alternateUrl;
      }
    });
  }

  // eslint-disable-next-line class-methods-use-this
  findUrlForLanguage(language) {
    const links = toArray(document.querySelectorAll('[rel="alternate"]'));

    const linksForLanguage = links.filter((link) => (
      link.getAttribute('hreflang') === language
    ));

    return linksForLanguage.length ? linksForLanguage[0].href : null;
  }
}

LanguageSwitch.targets = [
  'link',
];

export default LanguageSwitch;
